import React, { Suspense, lazy, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "components/statistics/filter";
import { Limits } from "../limits";

// recharts and its d3 tree are ~100KB gzipped. Lazily loaded so the bucket list
// — the app's landing page — never pays for them, the same way the per-bucket
// statistics screen does it.
const OrganizationCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// Everything about this ORGANIZATION that is a number, on one screen.
//
// The same two kinds of number the per-bucket statistics screen keeps apart,
// and the layout keeps them apart here for the same reason:
//
//   Limits    ABSOLUTE. What the organization is allowed across every bucket
//             and how much is gone, aggregated over the limit's own period.
//             Not affected by the range picker — a quota does not mean anything
//             "in the last 24 hours" — which is why it sits ABOVE the filter.
//
//   The rest  DELTAS over the selected window, off two points: bytes from the
//             bucket-size point, counts of buckets/files/images/zips from the
//             statistics point. Every measure on both is a net change, so
//             nothing below the filter is a total.
//
// What this screen deliberately does NOT carry is the row-level listing. A
// capture-by-capture table across an organization is a fourth billed Timestream
// query answering a question this screen is not asking; the screen that does
// ask it is /bucket/:id/statistics, already scoped to the bucket whose bar was
// clicked. See docs/bucketws-statistics.md §8.
export const Content = () => {
  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Limits />
        </Col>
      </Row>

      {/* One filter row above everything it scopes. Both aggregates below
          re-render against this slice; neither has a filter of its own, and the
          Limits panel above is deliberately outside it.

          No extension input here, unlike the bucket screen: `ext` is a dimension
          of the size point and not of the statistics point, and datum makes an
          undeclared dimension an error rather than a dropped clause — so a
          filter the two reads could not share would break one of them. The API
          whitelists no filterable dimension on this path at all. */}
      <Row>
        <Col>
          <Filter showExt={false} onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <OrganizationCharts
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
